/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnersassigntitle2Inputs */

const en_partnersassigntitle2 = /** @type {(inputs: Partnersassigntitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assign a business`)
};

const de_partnersassigntitle2 = /** @type {(inputs: Partnersassigntitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betrieb zuordnen`)
};

/**
* | output |
* | --- |
* | "Assign a business" |
*
* @param {Partnersassigntitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnersassigntitle2 = /** @type {((inputs?: Partnersassigntitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnersassigntitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnersassigntitle2(inputs)
	return de_partnersassigntitle2(inputs)
});
export { partnersassigntitle2 as "partnersAssignTitle" }